export default __webpack_public_path__ + "static/media/Diagnosis.8f5b7f46.svg";